export enum cookieKey {
  AUTH_TOKEN = 'auth_token',
}
